import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function user(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@organization/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@organization/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@organization/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}